/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendlyReservations } from '../../models/calendly-reservations';

export interface ListCalendlyReservations$Params {
  eventTypeUuid: string;
}

export function listCalendlyReservations(http: HttpClient, rootUrl: string, params: ListCalendlyReservations$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendlyReservations>> {
  const rb = new RequestBuilder(rootUrl, listCalendlyReservations.PATH, 'get');
  if (params) {
    rb.path('eventTypeUuid', params.eventTypeUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendlyReservations>;
    })
  );
}

listCalendlyReservations.PATH = '/v1/api/ui/calendly-demo/event-types/{eventTypeUuid}/reservations';
